<template>
  <div
    v-if="isVisible"
    @click="open()"
    class="AmbiCardOpenButton"
    :class="{ '-IsFixed': fixedButton }"
    :style="calculatedStyles"
  >
    <div class="flex items-center gap-x-1 px-2 w-full">
      <aw-icon icon="filter-karta-light" class="w-7 h-7" />
      <div class="mr-8 font-america-m">{{ $t('Dárková karta') }}</div>
      <aw-icon icon="chevron-up" class="w-7 h-7 ml-auto" />
    </div>
  </div>
</template>

<script>
import { useAmbiCard } from '../composables/AmbiCard'

export default {
  setup() {
    const { visible, open, close, toggle, transitionState } = useAmbiCard()

    return {
      visible,
      open,
      close,
      toggle,
      transitionState
    }
  },

  props: {
    fixedButton: {
      type: Boolean,
      default: true
    },
    buttonType: {
      type: String,
      default: 'global'
    }
  },
  computed: {
    /* dulezita cast, globalni sticky button zobrazime jen tehdy pokud nejsme v detailu voucheru, 
      protoze tam je jiny button zafixovany JINDE a jeste tam jsou scroll hratky atd ...
      buttonType (global) zobrazujeme vsude krom detailu voucheru, ten ma vlastni logiku zobrazovani buttonu
      buttonType (inpage) zobrazujeme jen v detailu voucheru a ma vlastni logiku jinou nez globalni
      
     */
    isVisible() {
      // v pripade detailu v darkove karte neukazeme vubec ani jeden z buttonu
      console.log(this.$presenterInfo.name)

      if (
        (this.$presenter?.voucher?.id == 1 &&
          this.$presenterInfo.name === 'front.dk-voucher' &&
          this.$presenterInfo.action === 'detail') ||
        (this.$presenter?.voucher?.id == 1 &&
          this.$presenterInfo.name === 'front.user-section-ambi')
      ) {
        return false
      }

      // if (window.location.pathname === '/zazitky/darkova-karta-do-ambiente') {
      //   return false
      // }

      if (
        (this.buttonType == 'global' &&
          this.$presenterInfo.name == 'front.dk-voucher' &&
          this.$presenterInfo.action == 'detail') ||
        this.$presenterInfo.name === 'front.user-section-ambi'
      ) {
        return false
      }

      return true
    },

    defaultColors() {
      return {
        bg: '#c8102e',
        fg: '#fff'
      }
    },

    calculatedStyles() {
      return {
        '--bg-color':
          this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color || this.defaultColors.bg,
        '--bg-color-darken': this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color
          ? `color-mix(in srgb, ${this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color} 85%, black)`
          : `color-mix(in srgb, ${this.defaultColors.bg} 85%, black)`,
        '--fg-color':
          this.$controls?.ambiStickyCard?.voucher?.fg_sticky_card?.color || this.defaultColors.fg
      }
    }
  },
  mounted() {
    console.log('AMBI-STICKY-CARD-BUTTON', this.$controls.ambiStickyCard.voucher)
  }
}
</script>

<style lang="scss" scoped>
.AmbiCardOpenButton {
  @apply /*bg-ambi-red-ultradark border-ambi-red-ultradark-border*/ border-2  flex items-center  shadow-md;
  @apply rounded-lg cursor-pointer;
  z-index: 100;

  color: var(--fg-color);
  background: var(--bg-color-darken);
  border-color: var(--bg-color-darken);

  &:hover {
    background: var(--bg-color);
    border-color: var(--bg-color);

    /*
    @apply bg-ambi-red;
    @apply border-ambi-red;
    */
  }

  min-height: 40px;
  @screen md {
    min-height: 48px;
  }

  &.-IsFixed {
    @apply fixed bottom-4 left-4 sm:left-auto right-4;
  }
}
</style>
